import React from 'react';
import TakeoverAdContainer from './TakeoverAdContainer.jsx';
import PanoramaAdContainer from './PanoramaAdContainer.jsx';
import SkyscraperAdContainer from './SkyscraperAdContainer.jsx';

const AdRow = () =>
  <div className="row ad-row">
    <div className="takeover">
      <TakeoverAdContainer />
    </div>
    <div className="panorama col-xs-12">
      <PanoramaAdContainer />
    </div>
    <div className="skyscraper">
      <SkyscraperAdContainer />
    </div>
  </div>;

export default AdRow;



// WEBPACK FOOTER //
// ./src/component/Ads/AdRow.jsx